import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';

import React from 'react';
import { useSelector } from 'react-redux';

import { Output } from '../common/SingleInput';
import { MultiOutput } from '../common/MultiInput';
import { LoadNoLoadLabel } from '../common/LoadNoLoadLabel';

const ConveyorSummary = () => {
    const input = useSelector(state => state.conveyor.conveyor.body.input);
    const output = useSelector(state => state.conveyor.conveyor.body.output);
    const resistance = useSelector(state => state.conveyor.conveyor.body.resistance);
    // const tension = useSelector(state => state.conveyor.conveyor.body.tension);
    // const drives = useSelector(state => state.conveyor.conveyor.body.drives);
    // const power = useSelector(state => state.conveyor.conveyor.body.power);
    // const belt = useSelector(state => state.conveyor.conveyor.body.belt);


    return (
        <Wrapper>
            <InputSection>
                <Title>
                    <h3>Input</h3>
                </Title>
                <Content>
                    <Output
                        label="Capacity"
                        variable="Q"
                        unit="tph"
                        variableName="capacity"
                        value={input.capacity}
                    />
                    <Output
                        label="Conveyor Length"
                        variable="L"
                        unit="m"
                        variableName="length"
                        value={input.length}
                    />
                    <Output
                        label="Elevation Height"
                        variable="H"
                        unit="m"
                        variableName="height"
                        value={input.height}
                    />
                    <Output
                        label="Material Conveyed"
                        variable="-"
                        unit="-"
                        variableName="materialConveyed"
                        value={input.materialConveyed}
                    />
                    <Output
                        label="Apparent Specific Gravity of Material"
                        variable="⍴"
                        unit="kg/m3"
                        variableName="specificGravity"
                        value={input.specificGravity}
                    />
                    <Output
                        label="Belt Speed"
                        variable="v"
                        unit="m/s"
                        variableName="beltSpeed"
                        value={input.beltSpeed}
                    />
                    <Output
                        label="Belt Width"
                        variable="B"
                        unit="mm"
                        variableName="beltWidth"
                        value={input.beltWidth}
                    />
                    <Output
                        label="Belt Carcass Type"
                        variable="-"
                        unit="-"
                        variableName="carcassType"
                        value={input.carcassType}
                    />
                    <Output
                        label="Artificial Friction Coefficient"
                        variable="f"
                        unit="-"
                        variableName="artificialFrictionCoeff"
                        value={input.artificialFrictionCoeff}
                    />
                    <Output
                        label="Number of Pulleys"
                        variable="-"
                        unit="sets"
                        variableName="qtyPulley"
                        value={input.qtyPulley}
                    />
                    <Output
                        label="Installation Spacing of Carrying Idlers"
                        variable="a0"
                        unit="m"
                        variableName="carrySpacing"
                        value={input.carrySpacing}
                    />
                    <Output
                        label="Installation Spacing of Return Idlers"
                        variable="au"
                        unit="m"
                        variableName="returnSpacing"
                        value={input.returnSpacing}
                    />
                    <Output
                        label="Trough Angle"
                        variable="𝜆" // lamda
                        unit="deg."
                        variableName="troughAngle"
                        value={input.troughAngle}
                    />
                    <Output
                                label="Initial Speed of Material Handled"
                        variable="v0"
                        unit="m/s"
                        variableName="initialSpeed"
                        value={input.initialSpeed}
                    />
                    <Output
                        label="Front Tile Angle (Angle at Belt Plane)"
                        variable="𝜀" // epsilon
                        unit="deg."
                        variableName="tiltAngle"
                        value={input.tiltAngle}
                    />
                    <Output
                        label="Conveyor Length of Front Tilt Type Idlers Part"
                        variable="L𝜀" // Lepsilon
                        unit="m"
                        variableName="tiltLength"
                        value={input.tiltLength}
                    />
                    <Output
                        label="Friction Coefficient between the Idlers and the Belt"
                        variable="𝜇0"
                        unit="-"
                        variableName="frictionCoeffIdlerBelt"
                        value={input.frictionCoeffIdlerBelt}
                    />
                    <Output
                        label="Friction Coefficient between the Mateiral and the Belt"
                        variable="𝜇1"
                        unit="-"
                        variableName="frictionCoeffMaterialBelt"
                        value={input.frictionCoeffMaterialBelt}
                    />
                    <Output
                        label="Friction Coefficient between the Belt and the Skirtplate"
                        variable="𝜇2"
                        unit="-"
                        variableName="frictionCoeffBeltSkirt"
                        value={input.frictionCoeffBeltSkirt}
                    />
                    <Output
                        label="Friction Coefficient between the Belt and the Cleaner"
                        variable="𝜇3"
                        unit="-"
                        variableName="frictionCoeffBeltCleaner"
                        value={input.frictionCoeffBeltCleaner}
                    />
                    <Output
                        label="Q'ty of (External) Belt Cleaner"
                        variable="-"
                        unit="set(s)"
                        variableName="qtyBeltCleaner"
                        value={input.qtyBeltCleaner}
                    />
                    <Output
                        label="Pressure between the Belt and the Cleaner"
                        variable="P"
                        unit="N/m2"
                        variableName="cleanerContactPressure"
                        value={input.cleanerContactPressure}
                    />
                    <Output
                        label="Q'ty of Unloading Scraper"
                        variable="-"
                        unit="set(s)"
                        variableName="qtyUnloadingScraper"
                        value={input.qtyUnloadingScraper}
                    />
                    <Output
                        label="Scraping Coefficient of Unloading Scraper"
                        variable="ka"
                        unit="N/m"
                        variableName="scrapingCoeff"
                        value={input.scrapingCoeff}
                    />
                </Content>
            </InputSection>
            <InterCalcSection>
                <Title>
                    <h3>Internal Calculation</h3>
                </Title>
                <Content>
                    <Output
                        label="Value of Length Coefficient C"
                        variable="C"
                        unit="-"
                        variableName="lengthCoeff"
                        value={output.lengthCoeff}
                    />
                    <Output
                        label="Mass of Rotating Parts of Idler along the Carrying Side"
                        variable="qRO"
                        unit="kg/m"
                        variableName="massCarryIdler"
                        value={output.massCarryIdler}
                    />
                    <Output
                        label="Mass of Rotating Parts of Idler along the Return Side"
                        variable="qRU"
                        unit="kg/m"
                        variableName="massReturnIdler"
                        value={output.massReturnIdler}
                    />
                    <Output
                        label="Mass of Belt by JIS"
                        variable="qB"
                        unit="kg/m"
                        variableName="massBelt"
                        value={output.massBelt}
                    />
                    <Output
                        label="Belt Thickness by JIS"
                        variable="d"
                        unit="mm"
                        variableName="beltThick"
                        value={output.beltThick}
                    />
                    <Output
                        label="Volumetric Capacity"
                        variable="Iv"
                        unit="m3/s"
                        variableName="volumetricCapacity"
                        value={output.volumetricCapacity}
                    />
                    <Output
                        label="Skirtplate Width"
                        variable="b1"
                        unit="m"
                        variableName="skirtWidth"
                        value={output.skirtWidth}
                    />
                    <Output
                        label="Acceleration Area Length(@Skirt)"
                        variable="Ib"
                        unit="m"
                        variableName="accelerationLength"
                        value={output.accelerationLength}
                    />
                    <Output
                        label="Skirtplate Length"
                        variable="l"
                        unit="m"
                        variableName="skirtLength"
                        value={input.skirtLength}
                    />
                    <Output
                        label="Mass of Material Handled"
                        variable="qG"
                        unit="kg/m"
                        variableName="massMaterial"
                        value={output.massMaterial}
                    />
                    <Output
                        label="Slope Angle of Conveyor"
                        variable="𝛿"
                        unit="deg."
                        variableName="slopeAngle"
                        value={output.slopeAngle}
                    />
                    <Output
                        label="Trough Angle Coefficient"
                        variable="C𝜀" // Cepsilon
                        unit="deg."
                        variableName="troughAngleCoeff"
                        value={output.troughAngleCoeff}
                    />
                    <Output
                        label="Contact Area of Cleaner with Belt"
                        variable="A"
                        unit="m2"
                        variableName="cleanerContactArea"
                        value={output.cleanerContactArea}
                    />
                </Content>
            </InterCalcSection>
            <ResistanceSection>
                <Title>
                    <h3>Resistance</h3>
                </Title>
                <Content>
                    <LoadNoLoadLabel />
                    <MultiOutput
                        label="Main Resistance"
                        variable="FH"
                        unit="N"
                        variableName="main"
                        values={[resistance?.main?.load, resistance?.main?.noLoad]}
                        // values={[100, 200]}
                    />
                    <MultiOutput
                        label="Secondary Resistance"
                        variable="FN"
                        variableName="secondary"
                        unit="N"
                        values={[resistance?.secondary?.load, resistance?.secondary?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Acceleration Resistance of Material in Acc. Area"
                        variable="FN"
                        variableName="secondary1"
                        unit="N"
                        values={[resistance?.secondary1?.load, resistance?.secondary1?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Resistance between Material and the Skirt Plates in Acc. Area"
                        variable="Ff"
                        variableName="secondary2"
                        unit="N"
                        values={[resistance?.secondary2?.load, resistance?.secondary2?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Wrapping Resistance of Belt on Pulleys"
                        variable="Ft"
                        variableName="secondary3"
                        unit="N"
                        values={[resistance?.secondary3?.load, resistance?.secondary3?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Bearing Resistance of Pulley (Except Driving Pulley)"
                        variable="Ft"
                        variableName="secondary4"
                        unit="N"
                        values={[resistance?.secondary4?.load, resistance?.secondary4?.noLoad]}
                    />
                    <MultiOutput
                        label="Special Main Resistance"
                        variable="FN"
                        variableName="specialMain"
                        unit="N"
                        values={[resistance?.specialMain?.load, resistance?.specialMain?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Resistance when Idlers have tilted frontward"
                        variable="F𝜀" // Fepsilon
                        variableName="specialMain1"
                        unit="N"
                        values={[resistance?.specialMain1?.load, resistance?.specialMain1?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Resistance between Material and Skirtplates outside Acc. Area "
                        variable="FgL"
                        variableName="specialMain2"
                        unit="N"
                        values={[resistance?.specialMain2?.load, resistance?.specialMain2?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Friction Resistance due to Belt Cleaner"
                        variable="Fr"
                        variableName="specialMain3"
                        unit="N"
                        values={[resistance?.specialMain3?.load, resistance?.specialMain3?.noLoad]}
                    />
                    <MultiOutput
                        isSub
                        label="Friction Resistance of Unloading Scraper"
                        variable="Fa"
                        variableName="specialMain4"
                        unit="N"
                        values={[resistance?.specialMain4?.load, resistance?.specialMain4?.noLoad]}
                    />
                    <MultiOutput
                        label="Special Secondary Resistance, if Any"
                        variable="Fs2"
                        variableName="specialSecondary"
                        unit="N"
                        values={[resistance?.specialSecondary?.load, resistance?.specialSecondary?.noLoad]}
                    />
                    <MultiOutput
                        label="Slope Resistance"
                        variable="FST"
                        variableName="slope"
                        unit="N"
                        values={[resistance?.slope?.load, resistance?.slope?.noLoad]}
                    />
                    {/* <MultiOutput
                        label={
                            <AlertLabel
                                label="Horizontal Curve Resistance"
                                message="아래 Tension 계산 후 계산하면 자동으로 입력됩니다.\n以下のテンション計算後に計算すると自動的に入力されます。"
                            />
                        }
                        variable="-"
                        unit="N"
                        variableName="horizontalCurveResistance"
                        values={[horizontalCurveResistance?.load, horizontalCurveResistance?.noLoad]}
                        // values={[5000, 5000]}
                    /> */}
                    <MultiOutput
                        label="Overall Resistance"
                        variable="FU"
                        variableName="overall"
                        unit="N"
                        values={[resistance?.overall?.load, resistance?.overall?.noLoad]}
                    />
                </Content>
            </ResistanceSection>
        </Wrapper>
    );
};

export default ConveyorSummary;


/* =================   Styles   ================== */
const Wrapper = styled.div``;
const InputSection = styled.div``;
const InterCalcSection = styled.div``;
const ResistanceSection = styled.div``;
const Title = styled.div``;
const Content = styled.div``;
